var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "left-box",
          attrs: {
            "body-style":
              "height:calc(100vh - 150px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "30px",
                "margin-bottom": "10px",
                "margin-top": "10px",
                display: "flex",
                "align-items": "center",
                "flex-wrap": "wrap",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "300px", "margin-left": "10px" },
                    attrs: {
                      clearable: "",
                      placeholder: "请输入设备名称/编号",
                    },
                    model: {
                      value: _vm.searchData.Device,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchData, "Device", $$v)
                      },
                      expression: "searchData.Device",
                    },
                  }),
                  _c("el-input", {
                    staticStyle: { width: "300px", "margin-left": "10px" },
                    attrs: {
                      clearable: "",
                      placeholder: "请输入配件名称/编号",
                    },
                    model: {
                      value: _vm.searchData.Accessory,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchData, "Accessory", $$v)
                      },
                      expression: "searchData.Accessory",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.Search },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c("div", {}, [
                _c("span", { staticClass: "Quantity" }, [
                  _vm._v("配件数量小计：" + _vm._s(_vm.TotalQuantity)),
                ]),
                _c("span", { staticClass: "Quantity" }, [
                  _vm._v("配件数量总计：" + _vm._s(_vm.SumQuantity)),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-table",
                {
                  attrs: { height: "calc(100vh - 240px)", data: _vm.dataList },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "序号",
                      width: "55",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "DeviceCode",
                      label: "设备编号",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "DeviceName",
                      label: "设备名称",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "AccessoryCode",
                      label: "配件编号",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "AccessoryName",
                      label: "配件名称",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "TypeName",
                      label: "配件类型",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "AccessorySpec",
                      label: "配件规格",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "AccessoryNum",
                      label: "配件数量",
                      align: "right",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "SupplierName",
                      label: "供应商名称",
                      align: "center",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Supplier",
                      label: "生产厂家名称",
                      align: "center",
                      sortable: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                display: "flex",
                "align-items": "center",
                "justify-content": "right",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.PageIndex,
                  "page-sizes": _vm.pagination.PageSizes,
                  "page-size": _vm.pagination.PageRows,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }